import { Delete } from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  Box,
  FormControl,
  FormHelperText,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Link } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { forwardRef } from "react";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

interface IFileInputProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement> | null) => void;
  value?: File;
  label?: string;
  icon?: React.ReactNode;
  accept?: string;
  tooltip?: string;
  helperText?: React.ReactNode;
  error?: boolean;
  attachmentUrl?: string;
}

export const FileInput = forwardRef<HTMLInputElement, IFileInputProps>(
  (
    {
      onChange,
      label,
      icon,
      tooltip,
      error,
      helperText,
      attachmentUrl,
      ...props
    },
    ref,
  ) => {
    return (
      <FormControl error={!!error}>
        <Box>
          <Box display="flex" alignItems="center">
            {props.value ? (
              <Link
                href={attachmentUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {props.value.name}
              </Link>
            ) : (
              "Файл не выбран"
            )}
            {props.value && (
              <IconButton
                size="small"
                disableRipple
                onClick={() => onChange(null)}
              >
                <Delete fontSize="small" />
              </IconButton>
            )}
          </Box>
          <Tooltip title={tooltip}>
            <Button
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              startIcon={icon || <CloudUploadIcon />}
            >
              {label ? label : "Загрузить"}
              <VisuallyHiddenInput ref={ref} type="file" onChange={onChange} />
            </Button>
          </Tooltip>
        </Box>
        {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  },
);

FileInput.displayName = "FileInput";
